export const flashcardsTranslations = {
  fr: {
    title: 'Flashcards',
    subtitle: 'Système de révision par répétition espacée pour optimiser votre apprentissage',
    tabs: {
      study: 'Étudier',
      create: 'Créer',
      generate: 'Générer',
      stats: 'Statistiques',
      planning: 'Planning',
      manage: 'Gérer'
    },
    messages: {
      connectToAccess: 'Connectez-vous pour accéder aux flashcards',
      noCards: 'Aucune flashcard disponible',
      creating: 'Création en cours...',
      generating: 'Génération en cours...',
      studyComplete: 'Session d\'étude terminée !',
      cardsToReview: 'Cartes à réviser',
      newCards: 'Nouvelles cartes',
      reviewCards: 'Cartes en révision',
      loginButton: 'Se connecter',
      sessionClosed: 'Session d\'étude fermée'
    },
    decks: {
      publicLoadError: 'Erreur lors du chargement des decks publics',
      userLoadError: 'Erreur lors du chargement de vos decks',
      codeCopied: 'Code copié'
    },
    study: {
      cardsDueToday: '{{count}} carte(s) à réviser aujourd\'hui',
      noCardsDue: 'Aucune carte à réviser pour le moment',
      nextReview: 'Prochaine révision {{time}}',
      allCaughtUp: 'Bravo ! Vous êtes à jour 🎉',
      comeBackLater: 'Revenez {{time}} pour votre prochaine session',
      noUpcomingReviews: 'Créez des cartes pour commencer à réviser'
    },
    forms: {
      question: 'Question',
      answer: 'Réponse',
      questionPlaceholder: 'Entrez votre question...',
      answerPlaceholder: 'Entrez la réponse...',
      difficulty: 'Difficulté',
      tags: 'Tags'
    },
    buttons: {
      createManual: 'Créer manuellement',
      save: 'Sauvegarder',
      delete: 'Supprimer',
      edit: 'Modifier',
      showAnswer: 'Montrer la réponse',
      nextCard: 'Carte suivante',
      previousCard: 'Carte précédente',
      validateAndCreate: 'Valider et créer'
    },
    generate: {
      title: 'Générer des flashcards avec l\'IA',
      placeholder: 'Sujet ou thème pour générer des flashcards...',
      buttonText: 'Générer',
      description: 'L\'IA créera automatiquement des questions-réponses sur le sujet donné'
    },
    manage: {
      searchAndFilters: 'Recherche et filtres',
      loading: 'Chargement...',
      noCardsFound: 'Aucune carte trouvée',
      level: 'Niveau',
      streak: 'Série',
      description: 'Créez vos propres flashcards personnalisées'
    },
    freeCards: {
      consciousnessTitle: 'Flashcards Troubles de conscience',
      consciousnessDesc: '10 flashcards essentielles sur les troubles de conscience, disponibles immédiatement pour révision.',
      acrTitle: 'Flashcards ACR',
      acrDesc: '10 flashcards essentielles sur l\'arrêt cardiorespiratoire, disponibles immédiatement pour révision.',
      strokeTitle: 'Flashcards AVC',
      strokeDesc: '10 flashcards essentielles sur les accidents vasculaires cérébraux, disponibles immédiatement pour révision.',
      chestPainTitle: 'Flashcards Douleur Thoracique',
      chestPainDesc: '10 flashcards essentielles sur les douleurs thoraciques en médecine d\'urgence, disponibles immédiatement pour révision.',
      free: 'Gratuit'
    },
    shared: {
      previewCards: 'Aperçu des cartes',
      question: 'Question',
      answer: 'Réponse',
      moreCards: '+{{count}} cartes supplémentaires',
      copyDeck: 'Copier ce deck dans mon compte',
      copying: 'Copie en cours...',
      createFreeAccount: 'Créer un compte gratuit',
      shareDeck: 'Partager ce deck',
      copyToAccount: 'Copiez ce deck dans votre compte pour accéder à toutes les cartes',
      createAccountAccess: 'Créez un compte gratuit pour accéder à toutes les cartes',
      deckCopied: 'Deck "{{name}}" copié dans votre compte !',
      copyError: 'Erreur lors de la copie du deck',
      notFound: 'Deck introuvable',
      notFoundDesc: "Ce deck n'existe pas ou n'est plus public.",
      deckDescription: 'Deck de {{count}} flashcards médicales sur Sclépios IA',
      sharedBy: 'Partagé par',
      cards: 'cartes',
      shareText: 'Découvrez le deck "{{name}}" ({{count}} flashcards) sur Sclépios IA !',
    },
    collaboration: {
      title: 'Centre de Collaboration',
      sharedDecks: 'Decks Partagés',
      challenges: 'Défis',
      create: 'Créer',
      myDecksSharing: 'Mes decks - Options de partage',
      sharedWithMe: 'Decks partagés avec moi',
      by: 'Par',
      cards: 'cartes',
      noSharedDecks: 'Aucun deck partagé avec vous pour le moment',
      publicDecks: 'Decks publics populaires',
      useDeck: 'Utiliser ce deck',
      noPublicDecks: 'Aucun deck public disponible pour le moment',
      activeChallenges: 'Défis actifs',
      createdBy: 'Créé par',
      participants: 'Participants',
      start: 'Début',
      end: 'Fin',
      join: 'Rejoindre',
      leaderboard: 'Classement',
      noChallenges: 'Aucun défi actif pour le moment',
      challengeLeaderboard: 'Classement du défi',
      accuracy: 'précision',
      points: 'points',
      speedChallenge: 'Défi Révision Rapide',
      speedChallengeDesc: 'Révisez 20 cartes en moins de 15 minutes',
      volumeChallenge: 'Marathon de Mémorisation',
      volumeChallengeDesc: 'Révisez 100 cartes cette semaine',
      unknownOwner: 'Propriétaire inconnu',
      unknownAuthor: 'Auteur inconnu',
      unknownUser: 'Utilisateur inconnu',
      typeSpeed: 'Vitesse',
      typeAccuracy: 'Précision',
      typeStreak: 'Série',
      typeVolume: 'Volume',
      typeOther: 'Autre',
    },
    search: {
      placeholder: 'Rechercher dans vos cartes...'
    },
    myCards: {
      title: 'Mes cartes',
      allModes: 'Tous les modes',
      manual: 'Manuel'
    },
    planning: {
      empty: 'Aucune révision prévue',
      emptyDescription: 'Créez des flashcards pour commencer votre planning de révision'
    },
    stats: {
      level: 'Niveau'
    },
    rating: {
      correct: 'Correct',
      incorrect: 'Incorrect',
      easy: 'Facile',
      medium: 'Moyen',
      hard: 'Difficile',
      veryHard: 'Très difficile',
      again: 'Revoir',
      good: 'Bien'
    },
    toasts: {
      cardsGenerated: '{{count}} carte(s) générée(s) avec succès',
      cardsReadyForStudy: 'Les cartes sont prêtes pour la révision',
      generationComplete: 'Génération terminée avec succès',
      fillBothFields: 'Veuillez remplir les deux champs',
      userNotConnected: 'Utilisateur non connecté',
      cardCreated: 'Carte créée avec succès',
      cardDeleted: 'Carte supprimée avec succès',
      sessionCompleted: 'Session d\'étude terminée',
      revisionsStored: 'Révisions stockées avec succès',
      duplicatesDetected: '{{count}} flashcards générées mais aucune nouvelle carte (doublons détectés)',
      addError: 'Erreur lors de l\'ajout des flashcards',
      adding: 'Ajout en cours...',
      addAcr: 'Ajouter les flashcards ACR',
      addConsciousness: 'Ajouter les flashcards troubles de conscience',
      addStroke: 'Ajouter les flashcards AVC',
      addChestPain: 'Ajouter les flashcards douleur thoracique',
      flashcardCreated: 'Flashcard créée !',
      flashcardCreatedDesc: 'Votre flashcard a été créée avec succès',
      createError: 'Impossible de créer la flashcard',
      fillRequired: 'Veuillez remplir tous les champs obligatoires',
      prefsSaved: 'Préférences sauvegardées',
      prefsSavedDesc: 'Vos préférences de notification ont été mises à jour.',
      prefsError: 'Impossible de sauvegarder les préférences',
      sessionStarted: 'Session démarrée',
      sessionStartedDesc: 'Révision rapide de {{count}} cartes lancée!',
      sessionError: 'Impossible de démarrer la session'
    },
    creator: {
      title: 'Créer une flashcard',
      question: 'Question *',
      questionPlaceholder: 'Entrez votre question...',
      answer: 'Réponse *',
      answerPlaceholder: 'Entrez la réponse...',
      category: 'Catégorie',
      creating: 'Création...',
      createButton: 'Créer la flashcard'
    },
    quickReview: {
      title: 'Centre de Révision Rapide',
      sessionConfig: 'Configuration de la session',
      targetCards: 'Nombre de cartes cibles',
      timeLimit: 'Temps limite (minutes)',
      showTimer: 'Afficher le chronomètre',
      shuffleCards: 'Mélanger les cartes',
      starting: 'Démarrage...',
      startReview: 'Commencer la révision',
      notifPrefs: 'Préférences de notification',
      morningReminders: 'Rappels matinaux',
      eveningReminders: 'Rappels du soir',
      weekendReminders: 'Rappels le week-end',
      quickReviewEnabled: 'Révision rapide activée',
      saving: 'Sauvegarde...',
      savePrefs: 'Sauvegarder les préférences'
    },
    importExport: {
      title: 'Import/Export de Flashcards (Données Réelles)',
      importTitle: 'Importer des flashcards (Parser réel)',
      supportedFormats: 'Formats supportés',
      assignDeck: 'Assigner à un deck (optionnel)',
      noDeckSelected: 'Aucun deck sélectionné',
      cards: 'cartes',
      processing: 'Traitement réel en cours...',
      csvInfo: 'CSV: colonnes obligatoires "question" et "answer"',
      jsonInfo: 'JSON: array d\'objets avec question et answer',
      maxSize: 'Taille maximum: 10 MB',
      exportTitle: 'Exporter un deck (Données réelles)',
      selectDeck: 'Sélectionner un deck',
      chooseDeck: 'Choisir un deck à exporter',
      exportFormat: 'Format d\'export',
      download: 'Télécharger le fichier',
      csvExportInfo: 'CSV: Compatible Excel et tableurs',
      jsonExportInfo: 'JSON: Format structuré pour développeurs',
      includesProgress: 'Inclut les données de progression (maîtrise, ease_factor)',
      historyTitle: 'Historique des opérations (Base de données)',
      noHistory: 'Aucune opération d\'import/export réalisée pour le moment',
      statusSuccess: 'Réussi',
      statusFailed: 'Échec',
      statusPending: 'En cours',
      statusUnknown: 'Inconnu'
    },
    errors: {
      loadCards: 'Erreur lors du chargement des cartes',
      deleteCard: 'Erreur lors de la suppression de la carte',
      generation: 'Erreur lors de la génération des flashcards',
      serviceUnavailable: 'Impossible de contacter le service de génération. Vérifiez votre connexion.',
      rateLimit: 'Limite de requêtes atteinte. Veuillez patienter avant de réessayer.',
      usageLimit: 'Limite d\'usage mensuelle atteinte. Considérez une mise à niveau.',
      apiKey: 'Clé API OpenAI non configurée. Contactez l\'administrateur.',
      unexpectedFormat: 'Format de réponse inattendu de l\'IA',
      creation: 'Erreur lors de la création de la flashcard',
      security: 'Erreur de sécurité : vérifiez votre connexion',
      missingFields: 'Erreur : champs requis manquants',
      profileLoad: 'Erreur lors du chargement du profil',
      sessionStart: 'Erreur lors du démarrage de session',
      sessionEnd: 'Erreur lors de la fin de session'
    },
    units: {
      cards_one: '{{count}} carte',
      cards_other: '{{count}} cartes'
    },
    confidence: {
      question: 'Comment avez-vous trouvé cette question ?',
      veryHard: 'Très difficile',
      hard: 'Difficile',
      medium: 'Moyen',
      easy: 'Facile',
      veryEasy: 'Très facile',
    },
    mastery: {
      mastered: 'Maîtrisé',
      good: 'Bon',
      medium: 'Moyen',
      beginner: 'Débutant',
      new: 'Nouveau',
    }
  },
  en: {
    title: 'Flashcards',
    subtitle: 'Spaced repetition system to optimize your learning',
    tabs: {
      study: 'Study',
      create: 'Create',
      generate: 'Generate',
      stats: 'Statistics',
      planning: 'Planning',
      manage: 'Manage'
    },
    messages: {
      connectToAccess: 'Log in to access flashcards',
      noCards: 'No flashcards available',
      creating: 'Creating...',
      generating: 'Generating...',
      studyComplete: 'Study session completed!',
      cardsToReview: 'Cards to review',
      newCards: 'New cards',
      reviewCards: 'Review cards',
      loginButton: 'Log in',
      sessionClosed: 'Study session closed'
    },
    decks: {
      publicLoadError: 'Error loading public decks',
      userLoadError: 'Error loading your decks',
      codeCopied: 'Code copied'
    },
    study: {
      cardsDueToday: '{{count}} card(s) due for review today',
      noCardsDue: 'No cards due for review right now',
      nextReview: 'Next review {{time}}',
      allCaughtUp: 'Great job! You\'re all caught up 🎉',
      comeBackLater: 'Come back {{time}} for your next session',
      noUpcomingReviews: 'Create cards to start reviewing'
    },
    forms: {
      question: 'Question',
      answer: 'Answer',
      questionPlaceholder: 'Enter your question...',
      answerPlaceholder: 'Enter the answer...',
      difficulty: 'Difficulty',
      tags: 'Tags'
    },
    buttons: {
      createManual: 'Create manually',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      showAnswer: 'Show answer',
      nextCard: 'Next card',
      previousCard: 'Previous card',
      validateAndCreate: 'Validate and create'
    },
    generate: {
      title: 'Generate flashcards with AI',
      placeholder: 'Topic or theme to generate flashcards...',
      buttonText: 'Generate',
      description: 'AI will automatically create question-answer pairs on the given topic'
    },
    manage: {
      searchAndFilters: 'Search and filters',
      loading: 'Loading...',
      noCardsFound: 'No cards found',
      level: 'Level',
      streak: 'Streak',
      description: 'Create your own custom flashcards'
    },
    freeCards: {
      consciousnessTitle: 'Consciousness Disorders Flashcards',
      consciousnessDesc: '10 essential flashcards on consciousness disorders, available immediately for review.',
      acrTitle: 'Cardiac Arrest Flashcards',
      acrDesc: '10 essential flashcards on cardiac arrest, available immediately for review.',
      strokeTitle: 'Stroke Flashcards',
      strokeDesc: '10 essential flashcards on strokes, available immediately for review.',
      chestPainTitle: 'Chest Pain Flashcards',
      chestPainDesc: '10 essential flashcards on chest pain in emergency medicine, available immediately for review.',
      free: 'Free'
    },
    shared: {
      previewCards: 'Card Preview',
      question: 'Question',
      answer: 'Answer',
      moreCards: '+{{count}} more cards',
      copyDeck: 'Copy this deck to my account',
      copying: 'Copying...',
      createFreeAccount: 'Create a free account',
      shareDeck: 'Share this deck',
      copyToAccount: 'Copy this deck to your account to access all cards',
      createAccountAccess: 'Create a free account to access all cards',
      deckCopied: 'Deck "{{name}}" copied to your account!',
      copyError: 'Error copying deck',
      notFound: 'Deck not found',
      notFoundDesc: 'This deck does not exist or is no longer public.',
      deckDescription: 'Deck of {{count}} medical flashcards on Sclépios AI',
      sharedBy: 'Shared by',
      cards: 'cards',
      shareText: 'Discover the deck "{{name}}" ({{count}} flashcards) on Sclépios AI!',
    },
    collaboration: {
      title: 'Collaboration Center',
      sharedDecks: 'Shared Decks',
      challenges: 'Challenges',
      create: 'Create',
      myDecksSharing: 'My decks - Sharing options',
      sharedWithMe: 'Decks shared with me',
      by: 'By',
      cards: 'cards',
      noSharedDecks: 'No decks shared with you yet',
      publicDecks: 'Popular public decks',
      useDeck: 'Use this deck',
      noPublicDecks: 'No public decks available yet',
      activeChallenges: 'Active challenges',
      createdBy: 'Created by',
      participants: 'Participants',
      start: 'Start',
      end: 'End',
      join: 'Join',
      leaderboard: 'Leaderboard',
      noChallenges: 'No active challenges at the moment',
      challengeLeaderboard: 'Challenge leaderboard',
      accuracy: 'accuracy',
      points: 'points',
      speedChallenge: 'Quick Review Challenge',
      speedChallengeDesc: 'Review 20 cards in under 15 minutes',
      volumeChallenge: 'Memorization Marathon',
      volumeChallengeDesc: 'Review 100 cards this week',
      unknownOwner: 'Unknown owner',
      unknownAuthor: 'Unknown author',
      unknownUser: 'Unknown user',
      typeSpeed: 'Speed',
      typeAccuracy: 'Accuracy',
      typeStreak: 'Streak',
      typeVolume: 'Volume',
      typeOther: 'Other',
    },
    search: {
      placeholder: 'Search in your cards...'
    },
    myCards: {
      title: 'My cards',
      allModes: 'All modes',
      manual: 'Manual'
    },
    planning: {
      empty: 'No reviews scheduled',
      emptyDescription: 'Create flashcards to start your review planning'
    },
    stats: {
      level: 'Level'
    },
    rating: {
      correct: 'Correct',
      incorrect: 'Incorrect',
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
      veryHard: 'Very hard',
      again: 'Again',
      good: 'Good'
    },
    toasts: {
      cardsGenerated: '{{count}} card(s) generated successfully',
      cardsReadyForStudy: 'Cards are ready for review',
      generationComplete: 'Generation completed successfully',
      fillBothFields: 'Please fill both fields',
      userNotConnected: 'User not connected',
      cardCreated: 'Card created successfully',
      cardDeleted: 'Card deleted successfully',
      sessionCompleted: 'Study session completed',
      revisionsStored: 'Revisions stored successfully',
      duplicatesDetected: '{{count}} flashcards generated but no new cards (duplicates detected)',
      addError: 'Error adding flashcards',
      adding: 'Adding...',
      addAcr: 'Add ACR flashcards',
      addConsciousness: 'Add consciousness disorders flashcards',
      addStroke: 'Add stroke flashcards',
      addChestPain: 'Add chest pain flashcards',
      flashcardCreated: 'Flashcard created!',
      flashcardCreatedDesc: 'Your flashcard has been created successfully',
      createError: 'Unable to create flashcard',
      fillRequired: 'Please fill all required fields',
      prefsSaved: 'Preferences saved',
      prefsSavedDesc: 'Your notification preferences have been updated.',
      prefsError: 'Unable to save preferences',
      sessionStarted: 'Session started',
      sessionStartedDesc: 'Quick review of {{count}} cards launched!',
      sessionError: 'Unable to start session'
    },
    creator: {
      title: 'Create a flashcard',
      question: 'Question *',
      questionPlaceholder: 'Enter your question...',
      answer: 'Answer *',
      answerPlaceholder: 'Enter the answer...',
      category: 'Category',
      creating: 'Creating...',
      createButton: 'Create flashcard'
    },
    quickReview: {
      title: 'Quick Review Center',
      sessionConfig: 'Session configuration',
      targetCards: 'Target card count',
      timeLimit: 'Time limit (minutes)',
      showTimer: 'Show timer',
      shuffleCards: 'Shuffle cards',
      starting: 'Starting...',
      startReview: 'Start review',
      notifPrefs: 'Notification preferences',
      morningReminders: 'Morning reminders',
      eveningReminders: 'Evening reminders',
      weekendReminders: 'Weekend reminders',
      quickReviewEnabled: 'Quick review enabled',
      saving: 'Saving...',
      savePrefs: 'Save preferences'
    },
    importExport: {
      title: 'Flashcard Import/Export (Real Data)',
      importTitle: 'Import flashcards (Real parser)',
      supportedFormats: 'Supported formats',
      assignDeck: 'Assign to a deck (optional)',
      noDeckSelected: 'No deck selected',
      cards: 'cards',
      processing: 'Real processing in progress...',
      csvInfo: 'CSV: required columns "question" and "answer"',
      jsonInfo: 'JSON: array of objects with question and answer',
      maxSize: 'Maximum size: 10 MB',
      exportTitle: 'Export a deck (Real data)',
      selectDeck: 'Select a deck',
      chooseDeck: 'Choose a deck to export',
      exportFormat: 'Export format',
      download: 'Download file',
      csvExportInfo: 'CSV: Compatible with Excel and spreadsheets',
      jsonExportInfo: 'JSON: Structured format for developers',
      includesProgress: 'Includes progress data (mastery, ease_factor)',
      historyTitle: 'Operations history (Database)',
      noHistory: 'No import/export operations yet',
      statusSuccess: 'Success',
      statusFailed: 'Failed',
      statusPending: 'Pending',
      statusUnknown: 'Unknown'
    },
    errors: {
      loadCards: 'Error loading cards',
      deleteCard: 'Error deleting card',
      generation: 'Error generating flashcards',
      serviceUnavailable: 'Unable to contact generation service. Check your connection.',
      rateLimit: 'Rate limit reached. Please wait before trying again.',
      usageLimit: 'Monthly usage limit reached. Consider upgrading.',
      apiKey: 'OpenAI API key not configured. Contact administrator.',
      unexpectedFormat: 'Unexpected AI response format',
      creation: 'Error creating flashcard',
      security: 'Security error: check your connection',
      missingFields: 'Error: required fields missing',
      profileLoad: 'Error loading profile',
      sessionStart: 'Error starting session',
      sessionEnd: 'Error ending session'
    },
    units: {
      cards_one: '{{count}} card',
      cards_other: '{{count}} cards'
    },
    confidence: {
      question: 'How did you find this question?',
      veryHard: 'Very hard',
      hard: 'Hard',
      medium: 'Medium',
      easy: 'Easy',
      veryEasy: 'Very easy',
    },
    mastery: {
      mastered: 'Mastered',
      good: 'Good',
      medium: 'Medium',
      beginner: 'Beginner',
      new: 'New',
    }
  },
  es: {
    title: 'Tarjetas de estudio',
    subtitle: 'Sistema de repetición espaciada para optimizar tu aprendizaje',
    tabs: {
      study: 'Estudiar',
      create: 'Crear',
      generate: 'Generar',
      stats: 'Estadísticas',
      planning: 'Planificación',
      manage: 'Gestionar'
    },
    messages: {
      connectToAccess: 'Inicia sesión para acceder a las tarjetas',
      noCards: 'No hay tarjetas disponibles',
      creating: 'Creando...',
      generating: 'Generando...',
      studyComplete: '¡Sesión de estudio completada!',
      cardsToReview: 'Tarjetas para repasar',
      newCards: 'Tarjetas nuevas',
      reviewCards: 'Tarjetas de repaso',
      loginButton: 'Iniciar sesión',
      sessionClosed: 'Sesión de estudio cerrada'
    },
    decks: {
      publicLoadError: 'Error al cargar los mazos públicos',
      userLoadError: 'Error al cargar tus mazos',
      codeCopied: 'Código copiado'
    },
    study: {
      cardsDueToday: '{{count}} tarjeta(s) para repasar hoy',
      noCardsDue: 'No hay tarjetas para repasar ahora',
      nextReview: 'Próxima revisión {{time}}',
      allCaughtUp: '¡Genial! Estás al día 🎉',
      comeBackLater: 'Vuelve {{time}} para tu próxima sesión',
      noUpcomingReviews: 'Crea tarjetas para empezar a repasar'
    },
    forms: {
      question: 'Pregunta',
      answer: 'Respuesta',
      questionPlaceholder: 'Introduce tu pregunta...',
      answerPlaceholder: 'Introduce la respuesta...',
      difficulty: 'Dificultad',
      tags: 'Etiquetas'
    },
    buttons: {
      createManual: 'Crear manualmente',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      showAnswer: 'Mostrar respuesta',
      nextCard: 'Siguiente tarjeta',
      previousCard: 'Tarjeta anterior',
      validateAndCreate: 'Validar y crear'
    },
    generate: {
      title: 'Generar tarjetas con IA',
      placeholder: 'Tema o asunto para generar tarjetas...',
      buttonText: 'Generar',
      description: 'La IA creará automáticamente pares pregunta-respuesta sobre el tema dado'
    },
    manage: {
      searchAndFilters: 'Búsqueda y filtros',
      loading: 'Cargando...',
      noCardsFound: 'No se encontraron tarjetas',
      level: 'Nivel',
      streak: 'Racha',
      description: 'Crea tus propias tarjetas personalizadas'
    },
    freeCards: {
      consciousnessTitle: 'Tarjetas Trastornos de conciencia',
      consciousnessDesc: '10 tarjetas esenciales sobre trastornos de conciencia, disponibles inmediatamente para revisión.',
      acrTitle: 'Tarjetas Paro Cardíaco',
      acrDesc: '10 tarjetas esenciales sobre paro cardíaco, disponibles inmediatamente para revisión.',
      strokeTitle: 'Tarjetas ACV',
      strokeDesc: '10 tarjetas esenciales sobre accidentes cerebrovasculares, disponibles inmediatamente para revisión.',
      chestPainTitle: 'Tarjetas Dolor Torácico',
      chestPainDesc: '10 tarjetas esenciales sobre dolor torácico en medicina de urgencia, disponibles inmediatamente para revisión.',
      free: 'Gratis'
    },
    shared: {
      previewCards: 'Vista previa de tarjetas',
      question: 'Pregunta',
      answer: 'Respuesta',
      moreCards: '+{{count}} tarjetas más',
      copyDeck: 'Copiar este mazo a mi cuenta',
      copying: 'Copiando...',
      createFreeAccount: 'Crear una cuenta gratis',
      shareDeck: 'Compartir este mazo',
      copyToAccount: 'Copia este mazo a tu cuenta para acceder a todas las tarjetas',
      createAccountAccess: 'Crea una cuenta gratis para acceder a todas las tarjetas',
      deckCopied: '¡Mazo "{{name}}" copiado a tu cuenta!',
      copyError: 'Error al copiar el mazo',
      notFound: 'Mazo no encontrado',
      notFoundDesc: 'Este mazo no existe o ya no es público.',
      deckDescription: 'Mazo de {{count}} tarjetas médicas en Sclépios IA',
      sharedBy: 'Compartido por',
      cards: 'tarjetas',
      shareText: '¡Descubre el mazo "{{name}}" ({{count}} tarjetas) en Sclépios IA!',
    },
    collaboration: {
      title: 'Centro de Colaboración',
      sharedDecks: 'Mazos Compartidos',
      challenges: 'Desafíos',
      create: 'Crear',
      myDecksSharing: 'Mis mazos - Opciones de compartir',
      sharedWithMe: 'Mazos compartidos conmigo',
      by: 'Por',
      cards: 'tarjetas',
      noSharedDecks: 'Ningún mazo compartido contigo por el momento',
      publicDecks: 'Mazos públicos populares',
      useDeck: 'Usar este mazo',
      noPublicDecks: 'Ningún mazo público disponible por el momento',
      activeChallenges: 'Desafíos activos',
      createdBy: 'Creado por',
      participants: 'Participantes',
      start: 'Inicio',
      end: 'Fin',
      join: 'Unirse',
      leaderboard: 'Clasificación',
      noChallenges: 'Ningún desafío activo por el momento',
      challengeLeaderboard: 'Clasificación del desafío',
      accuracy: 'precisión',
      points: 'puntos',
      speedChallenge: 'Desafío de Revisión Rápida',
      speedChallengeDesc: 'Revisa 20 tarjetas en menos de 15 minutos',
      volumeChallenge: 'Maratón de Memorización',
      volumeChallengeDesc: 'Revisa 100 tarjetas esta semana',
      unknownOwner: 'Propietario desconocido',
      unknownAuthor: 'Autor desconocido',
      unknownUser: 'Usuario desconocido',
      typeSpeed: 'Velocidad',
      typeAccuracy: 'Precisión',
      typeStreak: 'Racha',
      typeVolume: 'Volumen',
      typeOther: 'Otro',
    },
    search: {
      placeholder: 'Buscar en tus tarjetas...'
    },
    myCards: {
      title: 'Mis tarjetas',
      allModes: 'Todos los modos',
      manual: 'Manual'
    },
    planning: {
      empty: 'No hay repasos programados',
      emptyDescription: 'Crea tarjetas para comenzar tu planificación de repaso'
    },
    stats: {
      level: 'Nivel'
    },
    rating: {
      correct: 'Correcto',
      incorrect: 'Incorrecto',
      easy: 'Fácil',
      medium: 'Medio',
      hard: 'Difícil',
      veryHard: 'Muy difícil',
      again: 'Otra vez',
      good: 'Bien'
    },
    toasts: {
      cardsGenerated: '{{count}} tarjeta(s) generada(s) con éxito',
      cardsReadyForStudy: 'Las tarjetas están listas para revisión',
      generationComplete: 'Generación completada con éxito',
      fillBothFields: 'Por favor completa ambos campos',
      userNotConnected: 'Usuario no conectado',
      cardCreated: 'Tarjeta creada con éxito',
      cardDeleted: 'Tarjeta eliminada con éxito',
      sessionCompleted: 'Sesión de estudio completada',
      revisionsStored: 'Revisiones almacenadas con éxito',
      duplicatesDetected: '{{count}} tarjetas generadas pero no hay tarjetas nuevas (duplicados detectados)',
      addError: 'Error al agregar las tarjetas',
      adding: 'Agregando...',
      addAcr: 'Agregar tarjetas ACR',
      addConsciousness: 'Agregar tarjetas trastornos de conciencia',
      addStroke: 'Agregar tarjetas ACV',
      addChestPain: 'Agregar tarjetas dolor torácico',
      flashcardCreated: '¡Tarjeta creada!',
      flashcardCreatedDesc: 'Tu tarjeta ha sido creada con éxito',
      createError: 'No se pudo crear la tarjeta',
      fillRequired: 'Por favor completa todos los campos obligatorios',
      prefsSaved: 'Preferencias guardadas',
      prefsSavedDesc: 'Tus preferencias de notificación han sido actualizadas.',
      prefsError: 'No se pudieron guardar las preferencias',
      sessionStarted: 'Sesión iniciada',
      sessionStartedDesc: '¡Revisión rápida de {{count}} tarjetas lanzada!',
      sessionError: 'No se pudo iniciar la sesión'
    },
    creator: {
      title: 'Crear una tarjeta',
      question: 'Pregunta *',
      questionPlaceholder: 'Ingrese su pregunta...',
      answer: 'Respuesta *',
      answerPlaceholder: 'Ingrese la respuesta...',
      category: 'Categoría',
      creating: 'Creando...',
      createButton: 'Crear tarjeta'
    },
    quickReview: {
      title: 'Centro de Revisión Rápida',
      sessionConfig: 'Configuración de la sesión',
      targetCards: 'Número de tarjetas objetivo',
      timeLimit: 'Límite de tiempo (minutos)',
      showTimer: 'Mostrar cronómetro',
      shuffleCards: 'Mezclar tarjetas',
      starting: 'Iniciando...',
      startReview: 'Comenzar revisión',
      notifPrefs: 'Preferencias de notificación',
      morningReminders: 'Recordatorios matutinos',
      eveningReminders: 'Recordatorios nocturnos',
      weekendReminders: 'Recordatorios de fin de semana',
      quickReviewEnabled: 'Revisión rápida activada',
      saving: 'Guardando...',
      savePrefs: 'Guardar preferencias'
    },
    importExport: {
      title: 'Import/Export de Tarjetas (Datos Reales)',
      importTitle: 'Importar tarjetas (Parser real)',
      supportedFormats: 'Formatos soportados',
      assignDeck: 'Asignar a un mazo (opcional)',
      noDeckSelected: 'Ningún mazo seleccionado',
      cards: 'tarjetas',
      processing: 'Procesamiento real en curso...',
      csvInfo: 'CSV: columnas obligatorias "question" y "answer"',
      jsonInfo: 'JSON: array de objetos con question y answer',
      maxSize: 'Tamaño máximo: 10 MB',
      exportTitle: 'Exportar un mazo (Datos reales)',
      selectDeck: 'Seleccionar un mazo',
      chooseDeck: 'Elegir un mazo para exportar',
      exportFormat: 'Formato de exportación',
      download: 'Descargar archivo',
      csvExportInfo: 'CSV: Compatible con Excel y hojas de cálculo',
      jsonExportInfo: 'JSON: Formato estructurado para desarrolladores',
      includesProgress: 'Incluye datos de progreso (dominio, ease_factor)',
      historyTitle: 'Historial de operaciones (Base de datos)',
      noHistory: 'Ninguna operación de import/export realizada aún',
      statusSuccess: 'Exitoso',
      statusFailed: 'Fallido',
      statusPending: 'En curso',
      statusUnknown: 'Desconocido'
    },
    errors: {
      loadCards: 'Error cargando tarjetas',
      deleteCard: 'Error eliminando tarjeta',
      generation: 'Error generando tarjetas',
      serviceUnavailable: 'No se puede contactar el servicio de generación. Verifica tu conexión.',
      rateLimit: 'Límite de solicitudes alcanzado. Espera antes de intentar de nuevo.',
      usageLimit: 'Límite de uso mensual alcanzado. Considera actualizar.',
      apiKey: 'Clave API de OpenAI no configurada. Contacta al administrador.',
      unexpectedFormat: 'Formato de respuesta IA inesperado',
      creation: 'Error creando tarjeta',
      security: 'Error de seguridad: verifica tu conexión',
      missingFields: 'Error: campos requeridos faltantes',
      profileLoad: 'Error cargando perfil',
      sessionStart: 'Error iniciando sesión',
      sessionEnd: 'Error terminando sesión'
    },
    units: {
      cards_one: '{{count}} tarjeta',
      cards_other: '{{count}} tarjetas'
    },
    confidence: {
      question: '¿Cómo te pareció esta pregunta?',
      veryHard: 'Muy difícil',
      hard: 'Difícil',
      medium: 'Medio',
      easy: 'Fácil',
      veryEasy: 'Muy fácil',
    },
    mastery: {
      mastered: 'Dominado',
      good: 'Bueno',
      medium: 'Medio',
      beginner: 'Principiante',
      new: 'Nuevo',
    }
  }
};